import { Outlet, NavLink, useNavigate } from "react-router-dom";
import { useContext, useState } from "react";
import { Context } from "../../Reducers/Store";

export default function LayoutDashboard() {
  const navigate = useNavigate();
  const [state, dispatch] = useContext(Context);
  const [sidebarOpen, setSidebarOpen] = useState(false);
  const [sidebarCollapsed, setSidebarCollapsed] = useState(false);

  const nome = state?.profile?.displayName || "Usuário";
  const iniciais = nome ? nome.slice(0, 2).toUpperCase() : "?";

  const navLinks = [
    {
      to: "/dashboard",
      label: "Dashboard",
      icon: (
        <svg className="w-5 h-5 shrink-0" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M3 12l2-2m0 0l7-7 7 7M5 10v10a1 1 0 001 1h3m10-11l2 2m-2-2v10a1 1 0 01-1 1h-3m-6 0a1 1 0 001-1v-4a1 1 0 011-1h2a1 1 0 011 1v4a1 1 0 001 1m-6 0h6" />
        </svg>
      ),
    },
    {
      to: "/deploys",
      label: "Deploys",
      icon: (
        <svg className="w-5 h-5 shrink-0" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4 16v2a2 2 0 002 2h12a2 2 0 002-2v-2M12 12V4m0 0l-4 4m4-4l4 4" />
        </svg>
      ),
    },
    ...(state?.profile?.isAdministrator
      ? [
          {
            to: "/usuarios",
            label: "Usuários",
            icon: (
              <svg className="w-5 h-5 shrink-0" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M17 20h5v-2a4 4 0 00-3-3.87M9 20H4v-2a4 4 0 013-3.87m6-5.13a4 4 0 11-8 0 4 4 0 018 0zm6 3a3 3 0 11-6 0 3 3 0 016 0z" />
              </svg>
            ),
          },
          {
            to: "/maquinas",
            label: "Máquinas",
            icon: (
              <svg className="w-5 h-5 shrink-0" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 12V7a2 2 0 012-2h10a2 2 0 012 2v5M3 19h18M5 12h14a2 2 0 012 2v3a2 2 0 01-2 2H5a2 2 0 01-2-2v-3a2 2 0 012-2zM7 16h.01M11 16h.01" />
              </svg>
            ),
          },
          {
            to: "/ambientes",
            label: "Ambientes",
            icon: (
              <svg className="w-5 h-5 shrink-0" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 12h14M5 12a2 2 0 01-2-2V6a2 2 0 012-2h14a2 2 0 012 2v4a2 2 0 01-2 2M5 12a2 2 0 00-2 2v4a2 2 0 002 2h14a2 2 0 002-2v-4a2 2 0 00-2-2" />
              </svg>
            ),
          },
          { section: "Catálogos" },
          {
            to: "/git-configurations",
            label: "Git",
            icon: (
              <svg className="w-5 h-5 shrink-0" fill="none" stroke="currentColor" strokeWidth={2} strokeLinecap="round" strokeLinejoin="round" viewBox="0 0 24 24">
                <circle cx="6" cy="3" r="2" />
                <circle cx="6" cy="21" r="2" />
                <circle cx="18" cy="8" r="2" />
                <path d="M6 5v14" />
                <path d="M18 10v2a4 4 0 0 1-4 4H9" />
              </svg>
            ),
          },
          {
            to: "/build-configurations",
            label: "Build",
            icon: (
              <svg className="w-5 h-5 shrink-0" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M10 20l4-16m4 4l4 4-4 4M6 16l-4-4 4-4" />
              </svg>
            ),
          },
          {
            to: "/s3-configurations",
            label: "S3",
            icon: (
              <svg className="w-5 h-5 shrink-0" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M20 13V7a2 2 0 00-2-2H6a2 2 0 00-2 2v6m16 0l-2 8H6l-2-8m16 0H4m5 4h6" />
              </svg>
            ),
          },
          {
            to: "/database-restore-configurations",
            label: "DB Restore",
            icon: (
              <svg className="w-5 h-5 shrink-0" fill="none" stroke="currentColor" strokeWidth={2} strokeLinecap="round" strokeLinejoin="round" viewBox="0 0 24 24">
                <ellipse cx="12" cy="5" rx="9" ry="3" />
                <path d="M3 5v14a9 3 0 0 0 18 0V5" />
                <path d="M3 12a9 3 0 0 0 18 0" />
              </svg>
            ),
          },
        ]
      : []),
    {
      to: "/alterar-senha",
      label: "Alterar Senha",
      icon: (
        <svg className="w-5 h-5 shrink-0" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 7a2 2 0 012 2m4 0a6 6 0 01-7.743 5.743L11 17H9v2H7v2H4a1 1 0 01-1-1v-2.586a1 1 0 01.293-.707l5.964-5.964A6 6 0 1121 9z" />
        </svg>
      ),
    },
  ];

  const handleLogout = (e) => {
    e.preventDefault();
    localStorage.removeItem("jwt");
    dispatch({ type: "SET_LOGGED", payload: null });
    navigate("/login");
  };

  return (
    <div className="h-screen flex overflow-hidden bg-slate-50">
      {/* Overlay mobile */}
      {sidebarOpen && (
        <div
          className="fixed inset-0 bg-black/50 z-20 lg:hidden backdrop-blur-sm"
          onClick={() => setSidebarOpen(false)}
        />
      )}

      {/* Sidebar */}
      <aside
        className={`
          fixed lg:static inset-y-0 left-0 z-30 flex flex-col shrink-0
          transform transition-all duration-300 ease-in-out
          ${sidebarOpen ? "translate-x-0" : "-translate-x-full lg:translate-x-0"}
          ${sidebarCollapsed ? "lg:w-[90px]" : "lg:w-64"} w-64
        `}
        style={{ background: "linear-gradient(160deg, #1e1b4b 0%, #3b0764 100%)" }}
      >
        {/* Brand */}
        <div className="h-16 flex items-center gap-3 px-4 border-b border-white/10 shrink-0">
          <div
            className="w-8 h-8 rounded-xl flex items-center justify-center shrink-0"
            style={{ background: "linear-gradient(135deg,#8b5cf6,#6d28d9)" }}
          >
            <svg className="text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24" style={{ width: 18, height: 18 }}>
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2.5} d="M8 7V3m8 4V3m-9 8h10M5 21h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v12a2 2 0 002 2z" />
            </svg>
          </div>
          {!sidebarCollapsed && (
            <span className="text-white font-bold text-sm tracking-wide truncate">San Mateo Deployer</span>
          )}

          <button
            className="lg:hidden ml-auto text-purple-300 hover:text-white transition-colors"
            onClick={() => setSidebarOpen(false)}
          >
            <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
            </svg>
          </button>

          <button
            className={`hidden lg:block text-purple-400 hover:text-white transition-colors ${!sidebarCollapsed ? "ml-auto" : ""}`}
            onClick={() => setSidebarCollapsed(!sidebarCollapsed)}
            title={sidebarCollapsed ? "Expandir" : "Minimizar"}
          >
            <svg
              className={`w-5 h-5 transition-transform duration-300 ${sidebarCollapsed ? "rotate-180" : ""}`}
              fill="none" stroke="currentColor" viewBox="0 0 24 24"
            >
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M11 19l-7-7 7-7m8 14l-7-7 7-7" />
            </svg>
          </button>
        </div>

        {/* Nav */}
        <nav className="flex-1 px-3 py-5 space-y-1 overflow-y-auto">
          {!sidebarCollapsed && (
            <p className="text-xs font-semibold text-purple-400/50 uppercase tracking-widest px-3 mb-3">
              Menu
            </p>
          )}
          {navLinks.map((link, idx) => {
            if (link.section) {
              if (sidebarCollapsed) {
                return <div key={`sec-${idx}`} className="h-px bg-white/10 mx-3 my-2" />;
              }
              return (
                <p
                  key={`sec-${idx}`}
                  className="text-[10px] font-semibold text-purple-400/50 uppercase tracking-widest px-3 pt-4 pb-2"
                >
                  {link.section}
                </p>
              );
            }
            return (
              <NavLink
                key={link.to}
                to={link.to}
                onClick={() => setSidebarOpen(false)}
                title={sidebarCollapsed ? link.label : ""}
                className={({ isActive }) =>
                  `flex items-center gap-3 px-3 py-2.5 rounded-xl text-sm font-medium transition-all duration-150
                  ${isActive
                    ? "bg-violet-600 text-white shadow-lg shadow-violet-900/50"
                    : "text-purple-200/60 hover:bg-white/10 hover:text-white"
                  }
                  ${sidebarCollapsed ? "justify-center" : ""}`
                }
              >
                {link.icon}
                {!sidebarCollapsed && <span>{link.label}</span>}
              </NavLink>
            );
          })}
        </nav>

        {/* User + Logout */}
        <div className="border-t border-white/10 p-3 shrink-0 space-y-1">
          {!sidebarCollapsed && (
            <div className="flex items-center gap-3 px-2 py-2 rounded-xl">
              <div
                className="w-9 h-9 rounded-full flex items-center justify-center text-white text-xs font-bold shrink-0"
                style={{ background: "linear-gradient(135deg,#a78bfa,#7c3aed)" }}
              >
                {iniciais}
              </div>
              <div className="min-w-0">
                <p className="text-sm font-semibold text-white truncate">{nome}</p>
                <p className="text-xs text-purple-400">Usuário</p>
              </div>
            </div>
          )}
          <button
            onClick={handleLogout}
            title="Sair"
            className={`w-full flex items-center gap-3 px-3 py-2.5 text-sm font-medium text-red-400 hover:text-red-300 hover:bg-red-500/10 rounded-xl transition-all ${
              sidebarCollapsed ? "justify-center" : ""
            }`}
          >
            <svg className="w-5 h-5 shrink-0" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M17 16l4-4m0 0l-4-4m4 4H7m6 4v1a3 3 0 01-3 3H6a3 3 0 01-3-3V7a3 3 0 013-3h4a3 3 0 013 3v1" />
            </svg>
            {!sidebarCollapsed && <span>Sair</span>}
          </button>
        </div>
      </aside>

      {/* Main area */}
      <div className="flex-1 flex flex-col min-w-0 overflow-hidden">
        {/* Top header */}
        <header className="h-16 bg-white border-b border-slate-200 px-4 sm:px-6 flex items-center justify-between shrink-0">
          <button
            className="lg:hidden text-slate-500 hover:text-slate-800 transition-colors"
            onClick={() => setSidebarOpen(true)}
          >
            <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4 6h16M4 12h16M4 18h16" />
            </svg>
          </button>

          <div className="hidden lg:flex items-center gap-2 text-sm text-slate-500">
            <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M8 7V3m8 4V3m-9 8h10M5 21h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v12a2 2 0 002 2z" />
            </svg>
            <span>San Mateo Deployer</span>
          </div>

          <div className="flex items-center gap-3 ml-auto">
            <div className="text-right hidden sm:block">
              <p className="text-sm font-semibold text-slate-700">{nome}</p>
              <p className="text-xs text-slate-400">Usuário</p>
            </div>
            <div
              className="w-9 h-9 rounded-full flex items-center justify-center text-white text-xs font-bold"
              style={{ background: "linear-gradient(135deg,#a78bfa,#7c3aed)" }}
            >
              {iniciais}
            </div>
          </div>
        </header>

        <main className="flex-1 p-4 sm:p-6 lg:p-8 overflow-auto">
          <Outlet />
        </main>
      </div>
    </div>
  );
}
